import { Camera } from './camera.model';
import { ConfigModel } from './config-model.model'
import { User } from './user.model';
import { Model } from './model';
import * as moment from 'moment';

export class EventModel extends Model {
  public _id: string;
  public server_url: string;
  public stream_key: string;
  public start_date: string;
  public end_date: string;
  public stream_link: string;
  public logo: string;
  public textOverlay: string;
  public camera: Camera;
  public config: ConfigModel;
  public user: User;

  constructor(data = {}) {
    super(data);
  }

  get attributeMap(): { [p: string]: any } {
    return {
      _id: String,
      server_url: String,
      stream_key: String,
      start_date: String,
      end_date: String,
      stream_link: String,
      logo: String,
      textOverlay: String,
      camera: Camera,
      config: ConfigModel,
      user: User,
    };
  }

  get start_date_label() {
    return moment(this.start_date).format('LLL');
  }

  get end_date_label() {
    return moment(this.end_date).format('LLL');
  }

  get status() {

    if (moment(this.start_date) < moment() && moment(this.end_date) > moment()) {
      return 'streaming';
    }
    if (moment(this.start_date) > moment()) {
      return 'waiting';
    }
    if (moment(this.end_date) < moment()) {
      return 'finished';
    }
  }

  get status_label() {
    if (this.status === 'streaming') {
      return 'Streaming';
    }
    if (this.status === 'waiting') {
      return 'Waiting';
    }
    if (this.status === 'finished') {
      return 'Finished';
    }
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/models/event-model.model.ts